// components/analytics/GoogleAnalytics.tsx
'use client'

import Script from 'next/script'

/* GA4 standalone is OPTIONAL. In our setup, GA4 is provisioned inside the
 * GTM container itself (GTM-KPQXJWFG -> G-JJFS86X0FS), so this component
 * normally renders nothing. It exists for the case where someone wants to
 * fire GA4 directly without GTM, by setting NEXT_PUBLIC_GA4_ID to a real
 * "G-XXXXXXXX" measurement ID.
 *
 * Skip on anything that looks like the env.example placeholder so we never
 * ship pageview pings to a fake property. The original check only matched
 * the bare string "XXXXXXXXXX", not the prefixed "G-XXXXXXXXXX" that
 * .env.example actually documents — so the placeholder used to slip
 * through and fire real network requests. Harden the check by also
 * rejecting anything that contains "XXX" (placeholder convention). */
function isPlaceholderId(id) {
    if (!id) return true;
    if (id === 'XXXXXXXXXX') return true;
    if (/^G-X+$/i.test(id)) return true;
    if (/X{4,}/.test(id)) return true;
    return false;
}

export default function GoogleAnalytics() {
    const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID

    if (isPlaceholderId(GA4_ID)) return null

    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`}
            />
            <Script
                id="google-analytics"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA4_ID}');
          `,
                }}
            />
        </>
    )
}